
import seeker from './avatarsMarketing/seeker.webp';
import seeker1 from './avatarsMarketing/seeker1.webp';
import bloom from './avatarsMarketing/bloom.webp';
import theBloom from './avatarsMarketing/The Bloom.webp';
import React, { useEffect, useState } from 'react';
import celestial from './avatarsMarketing/celestial.webp';
import theCelestial from './avatarsMarketing/The Celestial.webp';
import divine from './avatarsMarketing/divine.webp';
import theDivineWebp from './avatarsMarketing/The divine.webp';
import theSeekerWebp from './avatarsMarketing/The Seeker.webp';
import prayingSage from './avatarsMarketing/Praying Sage.webp';
import {Link} from "react-router-dom";

const avatarImages = [
  seeker,
  seeker1,
  bloom,
  theBloom,
  celestial,
  theCelestial,
  divine,
  theDivineWebp,
  theSeekerWebp,
  prayingSage,
];

export default function AvatarsCarousel() {
  // Add custom style for hiding native scrollbar and marquee animation
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .hide-native-scrollbar::-webkit-scrollbar { display: none; }
      .marquee {
        display: flex;
        width: max-content;
        animation: marquee 40s linear infinite;
      }
      .marquee:hover { animation-play-state: paused; }
      @keyframes marquee {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `;
    document.head.appendChild(style);
    return () => { document.head.removeChild(style); };
  }, []);
  // Duplicate images for seamless loop
  const images = [...avatarImages, ...avatarImages];

  // Messages for each image (first 10 only, then repeat)
  const avatarMessages = [
    'I’m Mystery — follow the unknown',
    'I’m Light — awaken and remember',
    'I’m Transformation — shed and rise',
    'I’m Courage — face the fire',
    'I’m Energy — move with purpose',
    'I’m Stillness — find me within',
    'I’m Spirit — eternal, unbroken',
    'I’m Courage — face the fire',
    'I’m Love — walk with me.',
    'I’m Passion — ignite within.'
  ];
  const [hoveredIdx, setHoveredIdx] = useState(null);

  return (
    <div className="w-full rounded-xl flex flex-col mt-20 items-center py-12 ">
      <h3 className="text-xl sm:text-3xl font-bold text-indigo-200 mb-8">Choose your path — Reset, Renew, Align with your purpose, and Rise.</h3>
      <div className="relative w-full max-w-4xl flex flex-col items-center">
        <div
          className="overflow-hidden w-full px-12 py-4 hide-native-scrollbar"
        >
          <div className="marquee gap-8">
            {images.map((src, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center min-w-45 relative"
                onMouseEnter={() => setHoveredIdx(idx)}
                onMouseLeave={() => setHoveredIdx(null)}
              >
                <img
                  src={src}
                  alt={`Archetype Avatar ${idx + 1}`}
                  className="rounded-2xl shadow-lg w-40 h-40 object-cover border-4 border-indigo-700 hover:scale-105 transition-transform duration-300"
                  draggable={false}
                />
                {hoveredIdx === idx && (
                  <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-indigo-900/80 rounded-2xl transition-opacity duration-300">
                    <span className="text-indigo-100 text-center text-lg font-semibold px-4">
                      {avatarMessages[idx % 10]}
                    </span>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        {/* 4-point indicators (static, for design only) */}
        <div className="flex justify-center mt-4 gap-3">
          {[0,1,2,3].map((idx) => (
            <span
              key={idx}
              className={`w-4 h-4 rounded-full border-2 border-indigo-400 bg-indigo-900 transition-all`}
            />
          ))}
        </div>
      </div>
      {/* Bullets in 2 columns */}
      <div className="mt-8 w-full max-w-5xl grid grid-cols-1 md:grid-cols-2 gap-6 text-indigo-50 text-base sm:text-lg">
        <ul className="space-y-4 list-disc list-inside">
          <li>The past is not a weight to carry, but a story to honor.</li>
          <li>The present is more than a moment—it’s an opening.</li>
          <li>Through healing, you create space.</li>
        </ul>
        <ul className="space-y-4 list-disc list-inside">
          <li>Through awareness, you return to yourself.</li>
          <li>Through purpose, you move forward with clarity.</li>
          <li>Step forward, for every breath is a beginning.</li>
        </ul>
      </div>

      {/* Quote centered below bullets */}
      <div className="mt-8 w-full flex justify-center">
        <blockquote className="italic text-indigo-200 mt-4 text-center text-lg max-w-4xl border-l-4 border-indigo-500 pl-4">
          “Every reflection, every ritual, every moment of stillness brings you closer to what has always been within you.”
        </blockquote>
      </div>

      {/* CTA button bottom right */}
      <div className="w-full max-w-4xl flex justify-end mt-12">
        <Link className="bg-indigo-600 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:bg-indigo-700 transition"
          to="/sanctuary/ritual"
        >
         Begin This Week’s Practice ➞
        </Link>
      </div>
    </div>
  );
}
